import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const CustomProgres = ({ segments, size }) => {
  return (
    <div className="custom-progress-wrapper">
      {segments.map((segment, index) => (
        <div
          key={index}
          style={{
            boxSizing: 'border-box',
            width: `${segment.weight}%`,
            backgroundColor: segment.color,
            height: size.height || '2px',
          }}
        />
      ))}
    </div>
  );
};

export default CustomProgres;

CustomProgres.propTypes = {
  segments: PropTypes.array,
  size: PropTypes.object,
};
